<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					
					<el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
                        <el-tab-pane label="操作日志" name="first" clor="red"></el-tab-pane>
                        <el-tab-pane label="异常日志" name="second" clor="red"></el-tab-pane>
                    </el-tabs>
					
				</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<OperateLogTable ref="operateLogTable" v-if="activeName=='first'"/>
		<ExceptionLogTable ref="exceptionLogTable" v-if="activeName=='second'"/>
		
    </div>
</template>

<script>
import OperateLogTable from "@/components_pages/Log/OperateLogTable";
import ExceptionLogTable from "@/components_pages/Log/ExceptionLogTable";

    export default {
        /*
         * 组件名
         */
        name: "Log",
        /**
         * 引用组件
         * */
        components: {
            ExceptionLogTable,
            OperateLogTable,
        },// components
        /**
         * 数据定义
         * */
        data(){
            return {
                activeName: 'first'
            }// return
        },// data()
        created(){
        },
        /**
         * 初始化加载
         */
        mounted() {
        	
        },// mounted
        /**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
        /**
         * 方法定义
         */
		methods:{
            /**
             * @Des 关闭路由
             * @Auth
             * @Date
             */
            closeRouter () {
                // 跳转到 首页
                this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
            },// closeRouter
            
            handleClick(tab, event) {
                if (tab.index == 0) {
                    //请求1
                } else if (tab.index == 1) {
                    //请求2
                } else if (tab.index == 2) {
                    //请求3
                }
            },// handleClick
			

        },//methods

    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>




// WEBPACK FOOTER //
// src/views/system-manager/log.vue